import { render, staticRenderFns } from "./TableOrders.vue?vue&type=template&id=31d019be&scoped=true"
import script from "./TableOrders.vue?vue&type=script&lang=js"
export * from "./TableOrders.vue?vue&type=script&lang=js"
import style0 from "./TableOrders.vue?vue&type=style&index=0&id=31d019be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d019be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataFooter,VDataTable})
